import "./App.css";
import HomePage from "./Components/HomePage";
import Configuration from "./Components/Configuration";
import { Routes, Route, Navigate } from "react-router-dom";

const App = () => {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Navigate to="/1" replace />} />
        <Route path="/:siteId" element={<HomePage />} />
        <Route path="/configuration/:siteId" element={<Configuration />} />
      </Routes>
    </div>
  );
};

export default App;
